import { Alert, Button, Loading } from '../common'
import { BodyContent } from '../content'
import useIntro from './useIntro'
import styles from './intro.module.scss'
import { CopyContainer } from '../common/copy'

const Intro = () => {
  const { zoneId, data, loading, error, filePath, handlers } = useIntro()
  const { handleStartZone } = handlers

  if (loading) {
    return <Loading loading fullscreen message="Loading intro..." />
  }

  if (error) {
    return <Alert title="Unable to start case">{error}</Alert>
  }

  if (data === null) {
    return <Alert title={zoneId}>Is not a case. Yet.</Alert>
  }

  return (
    <Loading loading={loading} fullscreen message="Loading intro...">
      {data && (
        <div className={styles.introRoot}>
          {data.intro?.content && (
            <CopyContainer padding="small">
              <BodyContent
                filePath={filePath}
                contentBlock={{
                  content: data.intro.content,
                }}
              />
            </CopyContainer>
          )}
          <Button onClick={() => handleStartZone(data.id)}>
            {data.intro?.action || 'Take the case'}
          </Button>
        </div>
      )}
    </Loading>
  )
}

export default Intro
